module.exports = __webpack_public_path__ + "img/residencial_mensal_py.a83f1f71.webp";